export const convertSqmToSkm = (area: number): number => {
    return area / 1000000;
};

export const getSavedAreaIdFromParams = (
    searchParams: URLSearchParams
): string | undefined => {
    return searchParams.get("savedAreaId")?.split("+")[0] || undefined;
};

export const getSavedViewIdFromParams = (
    searchParams: URLSearchParams
): string | undefined => {
    return searchParams.get("savedViewId")?.split("+")[0] || undefined;
};

/**
 * A utility function to get a property from an object.
 *
 * @template T - The type of the object.
 * @template K - The key of the property to get.
 * @param {K} key - The key of the property to retrieve.
 * @returns {(obj: T) => T[K]} - A function that takes an object of type T and returns the value of the specified property.
 */
export const getProperty =
    <T, K extends keyof T>(key: K) =>
    (obj: T) =>
        obj[key];
